export default __webpack_public_path__ + "static/media/flower0875.b5520225.mp4";